import React from "react";

export default function Forecast({ weatherInfo, date }) {
  return (
    <div>
      <h1 className="Forecast__title">{[date[0], date[1], date[2]]}</h1>
      <img
        className="Forecast__weather-icon"
        src={
          "https://openweathermap.org/img/wn/" +
          weatherInfo.weather[0].icon +
          "@2x.png"
        }
        alt={weatherInfo.weather[0].main} 
        
      />
      <div className="Forecast__temperature">
        <span className="temperature__max">
          {Math.round(weatherInfo.temp.max)}
          <span className="forecast-temperature__symbol">°</span>
        </span>
        <span className="temperature__min">
          {Math.round(weatherInfo.temp.min)}
          <span className="forecast-temperature__symbol">°</span>
        </span>
      </div>
    </div>
  );
}